<div class="image-editor-modal-container">
    <div #imageEditorControl></div>
</div>